import {
  Button,
  Icon,
  IconButton,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { BlogKategori } from "../../const/types";
import { Trash } from "@phosphor-icons/react";
import { iconSize } from "../../const/sizes";
import cr from "../../lib/request";
import useTrigger from "../../globalState/useTrigger";

type Props = {
  data: BlogKategori;
};

export default function DeleteBlogKategoriModal({ data }: Props) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [loading, setLoading] = useState<boolean>(false);
  const toast = useToast();
  const { trigger, setTrigger } = useTrigger();

  const onDelete = () => {
    setLoading(true);
    const url = `api/blog/categories/${data.id}/destroy`;
    cr.delete(url)
      .then((r) => {
        if (r.status === 200) {
          toast({
            title: r.data.message,
            status: "success",
            duration: 5000,
            isClosable: true,
          });
          setTrigger(!trigger);
        }
      })
      .catch((e) => {
        console.log(e);
        toast({
          title: e.response.data.message,
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <IconButton
        onClick={onOpen}
        colorScheme="red"
        variant={"ghost"}
        aria-label="deleteKategori"
        className="clicky"
        icon={<Icon as={Trash} fontSize={iconSize} />}
      />

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />

        <ModalContent>
          <ModalHeader>Delete Kategori</ModalHeader>

          <ModalBody>
            <Text mb={4}>
              Apakah Anda yakin akan menghapus data ini <b>{data.name}</b>
            </Text>
            <Text opacity={0.5} fontSize={"small"}>
              Data kategori blog tidak dihapus permanen, kategori blog yang
              telah dihapus dapat dikembalikan lagi di menu <b>Restore</b>
            </Text>
          </ModalBody>

          <ModalFooter gap={2}>
            <Button onClick={onClose} className="btn clicky">
              Batal
            </Button>

            <Button
              type="submit"
              form={"deleteBlogKategoriForm"}
              colorScheme="red"
              className="clicky"
              onClick={onDelete}
              isLoading={loading}
            >
              Delete
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
